import { render } from "./Order.vue?vue&type=template&id=6defa9c9"
import script from "./Order.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Order.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script